import { Accordion, AccordionDetails } from '@material-ui/core';
import AccordionExpandIcon from 'components/SahamIcons/AccordionExpandIcon';
import { FC, MouseEventHandler } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { Grid, Typography } from '@material-ui/core';
import {
  StyledAccordionSummary,
  StyledTypography,
} from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/style';

interface CustomAccordionProps {
  title?: string;
  textColor: string;
  bgColor: string;
  image: string;
  editButtonTitle?: string | null;
  editButtonOnClick?: MouseEventHandler;
}
const styledIcon = {
  width: '16.5px',
  height: '16.5px',
  color: 'rgba(0, 117, 201, 1)',
};
const styledUpdate = {
  fontWeight: 500,
  lineHeight: '16px',
  fontSize: '15px',
  color: 'rgba(0, 117, 201, 1)',
};

const CustomAccordion: FC<CustomAccordionProps> = ({
  title,
  bgColor,
  textColor,
  children,
  image,
  editButtonTitle,
  editButtonOnClick,
}) => {
  return (
    <Accordion defaultExpanded={true}>
      <StyledAccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        expandIcon={<AccordionExpandIcon />}
        bgColor={bgColor}
        textColor={textColor}
      >
        {editButtonTitle && editButtonOnClick ? (
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <Grid container direction="row" spacing={2} alignItems="center">
                <Grid item>
                  <img
                    src={image}
                    className="request-icon"
                    alt="request-icon"
                  />
                </Grid>
                <Grid item xs>
                  <StyledTypography>{title}</StyledTypography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                direction="row"
                spacing={1}
                data-testId={'edit'}
                onClick={editButtonOnClick}
                style={{ cursor: 'pointer', marginRight: 20 }}
                alignItems="center"
              >
                <Grid item>
                  <EditIcon style={styledIcon} />
                </Grid>
                <Grid item>
                  <Typography style={styledUpdate}>
                    {editButtonTitle}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid container direction="row" spacing={2}>
            <Grid item>
              <img src={image} className="request-icon" alt="request-icon" />
            </Grid>
            <Grid item xs>
              <StyledTypography>{title}</StyledTypography>
            </Grid>
          </Grid>
        )}
      </StyledAccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
